import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { OpenInvoicesReport } from "@/pages/auswertungen/OpenInvoicesReport";

export function OpenInvoicesPage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["open-invoices"]}
    >
      <OpenInvoicesReport />
    </AppShell>
  );
}
